import logo from "../../assets/logo.png";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-black border-t border-white/5 mt-16">
      {/* MAIN FOOTER GRID */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 items-start">
          {/* COLUMN 1 — LOGO */}
          <div className="flex flex-col gap-2 items-center text-center">
            <img
              src={logo}
              alt="Afrodise Logo"
              className="h-20 object-contain"
            />
            <p className="text-sm text-gray-500 text-center leading-relaxed max-w-xs">
              {t("footer.tagline")}
            </p>
          </div>

          {/* COLUMN 2 — MUSIC */}
          <div className="flex flex-col gap-4 items-center text-center">
            <p className="text-sm font-semibold tracking-widest text-green-400/70 uppercase">
              {t("footer.musicTitle")}
            </p>
            <div className="flex flex-col gap-2">
              <a
                href="https://www.youtube.com/@afrodisemusic"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-500 hover:text-white transition"
              >
                YouTube
              </a>
              <a
                href="https://soundcloud.com/afrodisemusic"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-500 hover:text-white transition"
              >
                Soundcloud
              </a>
              <a
                href="https://www.beatport.com/label/afrodise/104331"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-500 hover:text-white transition"
              >
                Beatport
              </a>
              <a
                href="https://afrodisemusic.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-500 hover:text-white transition"
              >
                Afrodise Music
              </a>
            </div>
          </div>

          {/* COLUMN 3 — CONTACT */}
          <div className="flex flex-col gap-4 items-center text-center">
            <p className="text-sm font-semibold tracking-widest text-green-400/70 uppercase">
              {t("footer.contactTitle")}
            </p>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-gray-500 leading-relaxed">
                {t("footer.contactText")}{" "}
                <a
                  href="mailto:contact@afrodisemusic.com"
                  className="text-green-400/70 hover:text-green-400 transition"
                >
                  contact@afrodisemusic.eu
                </a>
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3 items-center text-center">
            <p className="text-sm font-semibold tracking-widest text-green-400/70 uppercase">
               {t("footer.legalTitle")}
            </p>
            <p className="text-sm text-gray-500 leading-relaxed">
               {t("footer.legalText")}
            </p>

            <a
              href="/tickets-store/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs tracking-widest uppercase px-4 py-2 rounded-full border border-green-900/40 text-green-400/70 hover:border-green-500/50 hover:text-green-400 transition"
            >
               {t("footer.legalButton")}
            </a>
          </div>
        </div>
      </div>

      {/* DIVIDER */}
      <div className="border-t border-white/10" />

      {/* COPYRIGHT */}
      <div className="max-w-6xl mx-auto px-6 py-6">
        <p className="text-[12px] text-white text-center leading-relaxed">
            {t("footer.copyright")}
          {/* <a
            href="https://simpexa.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-gray-300 transition"
          >
            Simpexa
          </a> */}
        </p>
      </div>
    </footer>
  );
}
